import React from 'react';
import {
  Grid, Paper, Typography, useTheme,
} from '@mui/material';
import accountStyles from '../../account/styles';
import bancameLogo from '../../../assets/bancame_logo_dark.svg';
import ConfirmDeletionView from '../../../feature/data-deletion/ConfirmDeletionView';
import analytics from '../../../utils/analytics';

type DataDeletionConfirmProps = {
  token: string;
};

export default function DataDeletionConfirm({ token }: DataDeletionConfirmProps) {
  const classes = accountStyles();
  const theme = useTheme();

  React.useEffect(() => {
    analytics.page('PU - ELIMINACIÓN DE DATOS', 'CONFIRMACIÓN');
  }, []);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.root}
      sx={{ minHeight: '100vh', padding: { xs: 2, md: 8 } }}
      style={{ backgroundColor: theme.palette.primary.main }}
    >
      <Paper
        elevation={1}
        sx={{
          borderRadius: '10px',
          padding: { xs: '24px 20px', md: '40px 48px' },
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <img
          src={bancameLogo}
          style={{ height: '25px', marginBottom: '32px' }}
          alt="Bancame"
        />
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
          Confirmar eliminación
        </Typography>
        <ConfirmDeletionView token={token} />
      </Paper>
    </Grid>
  );
}
